import { CheckIcon, MinusIcon } from "@heroicons/react/20/solid"
import React from "react"
import { connect } from "react-redux"

import Logo from "./assets/freshbooks-icon.svg"
const unfinished = true

const FreshbooksSettings = ({
  connected,
  needsVerification,
  connect,
  disconnect
}) => {
  return (
    <div className="col-sm-12 integration-row">
      <div className="col-sm-3">
        <img src={Logo} width="40px" />
        <span style={{ paddingLeft: 20, fontSize: 16 }}>FreshBooks</span>
      </div>
      <div className="col-sm-9">
        {unfinished ?
          <div className="btn btn-default pull-right">
            Coming Soon
          </div>
          :
          <>
            <button className="btn btn-primary pull-right" style={{ marginTop: 2 }} onClick={() => {
              if (connected) disconnect()
              else connect()
            }
            }>
              {connected ?
                <>
                  <MinusIcon style={{ height: "1.5em", float: "left" }} />
                  <div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
                </>
                :
                'Connect'
              }
            </button>
            {connected &&
              <button
                className={`btn ${needsVerification ? 'btn-primary' : 'btn-default'} pull-right`}
                style={{ marginTop: 2, marginRight: 10 }}
              >
                <CheckIcon style={{ height: "1.5em", float: "left" }} />
                <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Connected</div>
              </button>
            }
          </>
        }

      </div>
    </div >
  )
}

const mapStateToProps = (state) => {
  const { freshbooks } = state.integration?.accounting || {}

  return {
    connected: !!freshbooks,
  }
}

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(FreshbooksSettings)
